import React, {useEffect, useState} from 'react'
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Moment from 'moment';

const LastActivityHistory = ({
                            viewActivity,
                            activityByIdDetails=[],
                            match,
                        }) => {

    const date = new Date('2024-02-01')
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await viewActivity(match?.params?.id)
            setIsLoading(false)
        })()
    }, [])

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Activity'}
                        />
                        {/*BODY*/}
                        <div className="container-fluid">
                            {/*Heading*/}
                            <div className=" d-sm-flex align-items-center justify-content-between com-heading">
                                <h1 className="h3 mb-0 text-black-100">Account Details</h1>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="mb-0 bg-white">
                                        <div className="card-body">
                                            <div className="user">
                                                <div className="form-group row">
                                                    {activityByIdDetails?.data?.account_id !== null &&
                                                        activityByIdDetails?.data?.account_id !== "" && activityByIdDetails?.data?.account_id !== undefined &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       // handlePocInput(e.target.value, 'city', i)
                                                                   }}
                                                                   value={activityByIdDetails?.data?.account_id}
                                                                   disabled={true}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Account Id
                                                            </label>
                                                        </div>
                                                    }
                                                    {activityByIdDetails?.data?.account_name !== null &&
                                                        activityByIdDetails?.data?.account_name !== "" && activityByIdDetails?.data?.account_name !== undefined &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input type="text"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       // handlePocInput(e.target.value, 'city', i)
                                                                   }}
                                                                   value={activityByIdDetails?.data?.account_name}
                                                                   disabled={true}
                                                            />
                                                            <label
                                                                className="large-label float-lb">
                                                                Name of site
                                                            </label>
                                                        </div>
                                                    }
                                                    {activityByIdDetails?.data?.account_poc !== null &&
                                                        activityByIdDetails?.data?.account_poc !== undefined  && Object.keys(activityByIdDetails?.data?.account_poc).length > 0 &&
                                                        <>
                                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handlePocInput(e.target.value, 'city', i)
                                                                       }}
                                                                       value={activityByIdDetails?.data?.account_poc.name}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Poc Name
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handlePocInput(e.target.value, 'city', i)
                                                                       }}
                                                                       value={activityByIdDetails?.data?.account_poc.contact_no}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Poc Number
                                                                </label>
                                                            </div>
                                                        </>
                                                    }
                                                    {activityByIdDetails?.data?.address_1 !== null &&
                                                        activityByIdDetails?.data?.address_1 !== "" && activityByIdDetails?.data?.address_1 !== undefined &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <label style={{color:"#1b7cef"}}>Address</label>
                                                            <textarea
                                                                className="form-control form-control-user cus-red mb-4"
                                                                placeholder={"Solution Type"}
                                                                value={activityByIdDetails?.data?.address_1}
                                                                rows="4" cols="50"
                                                                // disabled={true}
                                                            />
                                                        </div>
                                                    }
                                                    {activityByIdDetails?.data?.solution_type !== null &&
                                                        activityByIdDetails?.data?.solution_type !== "" && activityByIdDetails?.data?.solution_type !== undefined &&
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <label style={{color:"#1b7cef"}}>Solution Type</label>
                                                                <textarea
                                                                    className="form-control form-control-user cus-red mb-4"
                                                                    placeholder={"Solution Type"}
                                                                    value={activityByIdDetails?.data?.solution_type}
                                                                    rows="4" cols="50"
                                                                    // disabled={true}
                                                                />
                                                        </div>
                                                    }

                                                    {activityByIdDetails?.data?.meta_data !== null &&
                                                        activityByIdDetails?.data?.meta_data !== "" && activityByIdDetails?.data?.meta_data !== undefined &&
                                                        activityByIdDetails?.data?.meta_data[0] && Object.keys(activityByIdDetails?.data?.meta_data[0]).length > 0 &&
                                                        activityByIdDetails?.data?.meta_data[0]['no_of_gates'] !== undefined &&
                                                        <>
                                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handlePocInput(e.target.value, 'city', i)
                                                                       }}
                                                                       value={activityByIdDetails?.data?.meta_data[0]['no_of_gates']}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    No of Gates
                                                                </label>
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/*{console.log(new Date(Moment(activityByIdDetails?.data?.activity_date).format('YYYY-MM-DD')), date)}*/}
                        {new Date(Moment(activityByIdDetails?.data?.activity_date).format('YYYY-MM-DD')) > date &&
                            <div className="container-fluid" style={{height:'0px'}}>
                                {/*Heading*/}
                                <div className=" d-sm-flex align-items-center justify-content-between com-heading">
                                    <h1 className="h3 mb-0 text-black-100">Last Metting</h1>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-0 bg-white">
                                            <div className="card-body">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        {activityByIdDetails?.data?.activity_name !== null &&
                                                            activityByIdDetails?.data?.activity_name !== "" && activityByIdDetails?.data?.activity_name !== undefined &&
                                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handlePocInput(e.target.value, 'city', i)
                                                                       }}
                                                                       value={activityByIdDetails?.data?.activity_name}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Activity Name
                                                                </label>
                                                            </div>
                                                        }
                                                        {activityByIdDetails?.data?.activity_date !== null &&
                                                            activityByIdDetails?.data?.activity_date !== "" && activityByIdDetails?.data?.activity_date !== undefined &&
                                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handlePocInput(e.target.value, 'city', i)
                                                                       }}
                                                                       value={Moment(activityByIdDetails?.data?.activity_date).format('DD/MM/YYYY HH:mm:ss')}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Activity Date
                                                                </label>
                                                            </div>
                                                        }
                                                        {activityByIdDetails?.data?.sub_activity_name !== null &&
                                                            activityByIdDetails?.data?.sub_activity_name !== "" && activityByIdDetails?.data?.sub_activity_name !== undefined &&
                                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handlePocInput(e.target.value, 'city', i)
                                                                       }}
                                                                       value={activityByIdDetails?.data?.sub_activity_name}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Meeting Stage
                                                                </label>
                                                            </div>
                                                        }
                                                        {activityByIdDetails?.data?.first_poc_details !== null &&
                                                            activityByIdDetails?.data?.first_poc_details !== "" && activityByIdDetails?.data?.first_poc_details !== undefined &&
                                                            <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handlePocInput(e.target.value, 'city', i)
                                                                       }}
                                                                       value={activityByIdDetails?.data?.first_poc_details}
                                                                       disabled={true}
                                                                />
                                                                <label
                                                                    className="large-label float-lb">
                                                                    Poc Details
                                                                </label>
                                                            </div>
                                                        }
                                                        {activityByIdDetails?.data?.meta_data !== null &&
                                                            activityByIdDetails?.data?.meta_data !== "" && activityByIdDetails?.data?.meta_data !== undefined &&
                                                            activityByIdDetails?.data?.meta_data[0] && Object.keys(activityByIdDetails?.data?.meta_data[0]).length > 0 &&
                                                            activityByIdDetails?.data?.meta_data[0]['MOM'] !== undefined &&
                                                            <>
                                                                <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                    <label style={{color:"#1b7cef"}}>MOM</label>
                                                                    <textarea
                                                                        className="form-control form-control-user cus-red mb-4"
                                                                        placeholder={"MOM"}
                                                                        value={activityByIdDetails?.data?.meta_data[0]['MOM']}
                                                                        rows="4" cols="50"
                                                                        // disabled={true}
                                                                    />
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        }

                        <div className="col-sm-6" >
                            <a href={activityByIdDetails?.data?.lead_id !== null ? `opportunity-list/${activityByIdDetails?.data?.account_id}/${activityByIdDetails?.data?.lead_id}` :`opportunity-list/${activityByIdDetails?.data?.account_id}`}
                               className="draft-float" style={{width:"127px"}}>
                                <p className="my-float"
                                   style={{ marginTop: "20px" }}>Opportunity</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LastActivityHistory;